import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {WithdrawalReceiverPaymentInfo} from '@gatewee/types/withdrawal';
import {UtilsModule} from '@gatewee/utils';
import {GateweeCollapsibleDirective} from '../gatewee-collapsible/gatewee-collapsible.directive';
import {GateweeExpandChevronComponent} from '../gatewee-expand-chevron/gatewee-expand-chevron.component';
import {GateweeIconComponent} from '../gatewee-icon/gatewee-icon.component';

@Component({
  selector: 'gatewee-withdrawal-receiver-info',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    UtilsModule,
    GateweeIconComponent,
    GateweeExpandChevronComponent,
    GateweeCollapsibleDirective,
  ],
  templateUrl: './gatewee-withdrawal-receiver-info.component.html',
  styleUrls: [
    './gatewee-withdrawal-receiver-info.component.css',
    '../styles/gatewee-collapsible-details.css',
  ],
})
export class GateweeWithdrawalReceiverInfoComponent {
  @Input() receiverPaymentInfo:
    | WithdrawalReceiverPaymentInfo
    | null
    | undefined;

  get info(): WithdrawalReceiverPaymentInfo | null | undefined {
    return this.receiverPaymentInfo;
  }

  /** Whether any display field is present (avoids empty collapsible). */
  get hasContent(): boolean {
    const p = this.receiverPaymentInfo;
    if (!p) {
      return false;
    }
    return !!(
      p.holderName ||
      p.holderDocument ||
      p.pixKey ||
      p.pixKeyType ||
      p.name ||
      p.document ||
      p.emvCode ||
      p.digitableLine
    );
  }
}
